export class Const {
}
//DOWNLOAD Commission list
Const.RUN_GET_COMMISSION_LIST = '/RUN_GET_COMMISSION_LIST';
Const.SET_COMMISSION_LIST = '/SET_COMMISSION_LIST';
Const.GET_COMMISSION_LIST = '/GET_COMMISSION_LIST';
//Upload Receipt
Const.RUN_UPLOAD_RECEIPT = '/RUN_UPLOAD_RECEIPT';
//getmarketholidays
Const.RUN_SET_MARKET_HOLIDAYS = '/RUN_SET_MARKET_HOLIDAYS';
// public static SET_VPS_LIST:string  =  '/SET_VPS_LIST'								
Const.GET_MARKET_HOLIDAYS = '/RUN_GET_MARKET_HOLIDAYS';
//getclienttoken
Const.RUN_GET_CLIENT_TOKEN = '/RUN_GET_CLIENT_TOKEN';
Const.RUN_GET_IB_LOGIN_TOKEN = '/RUN_GET_IB_LOGIN_TOKEN';
Const.RUN_GET_CLIENT_DATA = '/RUN_GET_CLIENT_DATA';
Const.SET_CLIENT_DATA = '/SET_CLIENT_DATA';
Const.GET_CLIENT_DATA = '/GET_CLIENT_DATA';
Const.RUN_GET_RM_LIST = '/RUN_GET_RM_LIST';
Const.RUN_BULK_UPDATE_RM_ACCURACY = '/RUN_BULK_UPDATE_RM_ACCURACY';
Const.RUN_IB_REQUEST_OTP = '/RUN_IB_REQUEST_OTP';
Const.RUN_IB_VERIFY_OTP = '/RUN_IB_VERIFY_OTP';
Const.GET_CLIENT_REPORT_LINK = '/GET_CLIENT_REPORT_LINK';
Const.RUN_GET_VPS_LIST = '/RUN_GET_VPS_LIST';
Const.SET_VPS_LIST = '/SET_VPS_LIST';
Const.GET_VPS_LIST = '/GET_VPS_LIST';
Const.RUN_GET_LOYALITY_TRANSACTION_LIST = '/RUN_GET_LOYALITY_TRANSACTION_LIST';
Const.SET_LOYALITY_TRANSACTION_LIST = '/SET_LOYALITY_TRANSACTION_LIST';
Const.GET_LOYALITY_TRANSACTION_LIST = '/GET_LOYALITY_TRANSACTION_LIST';
Const.RUN_GET_LOYALITY_CARD_LIST = '/RUN_GET_LOYALITY_CARD_LIST';
Const.SET_LOYALITY_CARD_LIST = '/SET_LOYALITY_CARD_LIST';
Const.GET_LOYALITY_CARD_LIST = '/GET_LOYALITY_CARD_LIST';
Const.RUN_GET_SUBSCRIPTION_LIST = '/RUN_GET_SUBSCRIPTION_LIST';
Const.SET_SUBSCRIPTION_LIST = '/SET_SUBSCRIPTION_LIST';
Const.GET_SUBSCRIPTION_LIST = '/GET_SUBSCRIPTION_LIST';
Const.RUN_GET_SUBSCRIPTION_DETAIL = '/RUN_GET_SUBSCRIPTION_DETAIL';
Const.SET_SUBSCRIPTION_DETAIL = '/SET_SUBSCRIPTION_DETAIL';
Const.GET_SUBSCRIPTION_DETAIL = '/GET_SUBSCRIPTION_DETAIL';
Const.RUN_USER_SUBSCRIPTION_END = '/RUN_USER_SUBSCRIPTION_END';
Const.RUN_USER_SUBSCRIPTION_UPDATE_ACCOUNT = '/RUN_USER_SUBSCRIPTION_UPDATE_ACCOUNT';
Const.RUN_USER_OTHER_DETAILS = '/RUN_USER_OTHER_DETAILS';
Const.SET_USER_OTHER_DETAILS = '/SET_USER_OTHER_DETAILS';
Const.GET_USER_OTHER_DETAILS = '/GET_USER_OTHER_DETAILS';
Const.RUN_ADD_WEBINAR = '/RUN_ADD_WEBINAR';
Const.RUN_GET_CITIES_LIST = '/RUN_GET_CITIES_LIST';
Const.SET_CITIES_LIST = '/SET_CITIES_LIST';
Const.GET_CITIES_LIST = '/GET_CITIES_LIST';
//tutorials
Const.RUN_CREATE_TUT_COURSE = '/RUN_CREATE_TUT_COURSE';
Const.RUN_CREATE_TUT_CAT = '/RUN_CREATE_TUT_CAT';
Const.RUN_CREATE_TUTORIAL = '/RUN_CREATE_TUTORIAL';
Const.RUN_GET_TUT_COURSE = '/RUN_GET_TUT_COURSE';
Const.SET_TUT_COURSE = '/SET_TUT_COURSE';
Const.GET_TUT_COURSE = '/GET_TUT_COURSE';
Const.RUN_GET_TUT_CAT = '/RUN_GET_TUT_CAT';
Const.SET_TUT_CAT = '/SET_TUT_CAT';
Const.GET_TUT_CAT = '/GET_TUT_CAT';
Const.RUN_GET_TUTORIAL_LIST = '/RUN_GET_TUTORIAL_LIST';
Const.SET_TUTORIAL_LIST = '/SET_TUTORIAL_LIST';
Const.GET_TUTORIAL_LIST = '/GET_TUTORIAL_LIST';
//trading education
Const.RUN_ADD_CATEGORY = '/RUN_ADD_CATEGORY';
Const.RUN_ADD_POST = '/RUN_ADD_POST';
Const.RUN_GET_CATEGORY_LIST = '/RUN_GET_CATEGORY_LIST';
Const.SET_CATEGORY_LIST = '/SET_CATEGORY_LIST';
Const.GET_CATEGORY_LIST = '/GET_CATEGORY_LIST';
Const.RUN_GET_POST_LIST = '/RUN_GET_POST_LIST';
Const.SET_POST_LIST = '/SET_POST_LIST';
Const.GET_POST_LIST = '/GET_POST_LIST';
//
Const.RUN_DOWNLOAD_DEPOSIT_FILE = '/RUN_DOWNLOAD_DEPOSIT_FILE';
Const.RUN_DOWNLOAD_WITHDRAWAL_FILE = '/RUN_DOWNLOAD_WITHDRAWAL_FILE';
Const.RUN_GET_COUNTRIES_LIST = '/RUN_GET_COUNTRIES_LIST';
Const.SET_COUNTRIES_LIST = '/SET_COUNTRIES_LIST';
Const.GET_COUNTRIES_LIST = '/GET_COUNTRIES_LIST';
Const.RUN_DOWNLOAD_COMMISSION_LIST_FILE = '/RUN_DOWNLOAD_COMMISSION_LIST_FILE';
//manage-group
Const.RUN_GET_MANAGE_GROUP_LIST = '/RUN_GET_MANAGE_GROUP_LIST';
Const.RUN_ADD_EDIT_ADMIN_MANAGE_GROUP_DATA = '/RUN_ADD_EDIT_ADMIN_MANAGE_GROUP_DATA';
//dashboard
Const.RUN_GET_DASHBOARD_DATA = '/RUN_GET_DASHBOARD_DATA';
Const.RUN_GET_DASHBOARD_OTHER_DATA = '/RUN_GET_DASHBOARD_OTHER_DATA';
Const.RUN_GET_TOTAL_CLIENT = '/RUN_GET_TOTAL_CLIENT';
//task
Const.RUN_GET_TASK_LIST = '/RUN_GET_TASK_LIST';
Const.RUN_ADD_TASK = '/RUN_ADD_TASK';
Const.RUN_TASK_UPDATE_STATUS = '/RUN_TASK_UPDATE_STATUS';
//permission
Const.SET_PERMISSION_LIST = '/SET_PERMISSION_LIST';
Const.GET_PERMISSION_LIST = '/GET_PERMISSION_LIST';
Const.SET_EMAIL_DATA = '/SET_EMAIL_DATA';
Const.GET_EMAIL_DATA = '/GET_EMAIL_DATA';
//email
Const.RUN_EMAIL_SETTING_LIST = '/RUN_EMAIL_SETTING_LIST';
Const.RUN_ADD_EMAIL_SETTING = '/RUN_ADD_EMAIL_SETTING';
Const.SET_EMAIL_SETTING_LIST = '/SET_EMAIL_SETTING_LIST';
Const.GET_EMAIL_SETTING_LIST = '/GET_EMAIL_SETTING_LIST';
//change-password
Const.RUN_CHANGE_PASSWORD = '/RUN_CHANGE_PASSWORD';
Const.RUN_GET_CHART_DATA = '/RUN_GET_CHART_DATA';
//coupon
Const.RUN_GET_COUPON_LIST = '/RUN_GET_COUPON_LIST';
Const.RUN_CREATE_COUPON = '/RUN_CREATE_COUPON';
Const.SET_COUPON_LIST = '/SET_COUPON_LIST';
Const.GET_COUPON_LIST = '/GET_COUPON_LIST';
//admin
Const.RUN_GET_ADMIN_LIST = '/RUN_GET_ADMIN_LIST';
Const.RUN_GET_ADMIN_DETAIL = '/RUN_GET_ADMIN_DETAIL';
Const.RUN_ADD_ADMIN = '/RUN_ADD_ADMIN';
Const.RUN_UPDATE_ADMIN_DETAIL = '/RUN_UPDATE_ADMIN_DETAIL';
Const.SET_ADMIN_LIST = '/SET_ADMIN_LIST';
Const.GET_ADMIN_LIST = '/GET_ADMIN_LIST';
Const.SET_ADMIN_DETAIL = '/SET_ADMIN_DETAIL';
Const.GET_ADMIN_DETAIL = '/GET_ADMIN_DETAIL';
Const.RUN_GET_NOTIFICATION_LIST = '/RUN_GET_NOTIFICATION_LIST';
Const.SET_ALL_NOTIFICATION_DATA = '/SET_ALL_NOTIFICATION_DATA';
Const.GET_ALL_NOTIFICATION_LIST = '/GET_NOTIFICATION_LIST';
Const.SET_UNREAD_NOTIFICATION_DATA = '/SET_UNREAD_NOTIFICATION_DATA';
Const.GET_UNREAD_NOTIFICATION_LIST = '/GET_UNREAD_NOTIFICATION_LIST';
Const.RUN_GET_NOTIFICATION_OLD = '/RUN_GET_NOTIFICATION_OLD';
Const.SET_NOTIFICATION_OLD_LIST = '/SET_NOTIFICATION_OLD_LIST';
Const.GET_NOTIFICATION_OLD_LIST = '/GET_NOTIFICATION_OLD_LIST';
Const.SET_GROUP_ADMIN_NAME = '/SET_GROUP_ADMIN_NAME';
Const.GET_GROUP_ADMIN_NAME = '/GET_GROUP_ADMIN_NAME';
Const.SET_USER_GROUP_ID = '/SET_USER_GROUP_ID';
Const.GET_USER_GROUP_ID = '/GET_USER_GROUP_ID';
//request access
Const.RUN_REQUEST_OTP = '/RUN_REQUEST_OTP';
Const.RUN_VERIFY_OTP = '/RUN_VERIFY_OTP';
//faq
Const.RUN_CREATE_CATEGORY = '/RUN_CREATE_CATEGORY';
Const.RUN_CREATE_ARTICLE = '/RUN_CREATE_ARTICLE';
Const.RUN_GET_ARTICLE_LIST = '/RUN_GET_ARTICLE_LIST';
Const.RUN_GET_CAT_LIST = '/RUN_GET_CAT_LIST';
Const.RUN_GET_CAT_DETAIL = '/RUN_GET_CAT_DETAIL';
Const.RUN_GET_ARTICLE_DETAIL = '/RUN_GET_ARTICLE_DETAIL';
Const.SET_ARTICLE_LIST = '/SET_ARTICLE_LIST';
Const.GET_ARTICLE_LIST = '/GET_ARTICLE_LIST';
Const.SET_CAT_LIST = '/SET_CAT_LIST';
Const.GET_CAT_LIST = '/GET_CAT_LIST';
//ib
Const.RUN_GET_IB_CHANGE_LIST = '/RUN_GET_IB_CHANGE_LIST';
Const.SET_IB_LIST = '/SET_IB_LIST';
Const.GET_IB_LIST = '/GET_IB_LIST';
//ib-change
Const.GET_IB_CHANGE_LIST = '/GET_IB_CHANGE_LIST';
Const.SET_IB_CHANGE_LIST = '/SET_IB_CHANGE_LIST';
//Sub Ib
Const.RUN_GET_SUB_IB_LIST = '/RUN_GET_SUB_IB_LIST';
Const.SET_SUB_IB_LIST = '/SET_SUB_IB_LIST';
Const.GET_SUB_IB_LIST = '/GET_SUB_IB_LIST';
Const.SET_IB_COUNT = '/SET_USER_COUNT';
Const.GET_IB_COUNT = '/GET_USER_COUNT';
Const.SET_IB_VIEW = '/SET_USER_VIEW';
Const.GET_IB_VIEW = '/GET_USER_VIEW';
Const.RUN_DELETE_ARTICLE = '/RUN_DELETE_ARTICLE';
Const.RUN_DELETE_CATEGORY = '/RUN_DELETE_CATEGORY';
//client
Const.RUN_GET_ALL_INTERNAL_NOTES = '/RUN_GET_ALL_INTERNAL_NOTES';
Const.RUN_CLOSE_ACCOUNT = '/RUN_CLOSE_ACCOUNT';
Const.RUN_GET_CLIENT_REPORT = '/RUN_GET_CLIENT_REPORT';
Const.RUN_ALLOW_FOR_IPV = '/RUN_ALLOW_FOR_IPV';
Const.RUN_SEND_EMAIL_USER = '/RUN_SEND_EMAIL_USER';
Const.RUN_GET_ACCOUNT_DETAIL = '/RUN_GET_ACCOUNT_DETAIL';
Const.SET_WITHDRAWAL_METHOD_RESPONSE = '/SET_WITHDRAWAL_METHOD_RESPONSE';
Const.GET_WITHDRAWAL_METHOD_RESPONSE = '/GET_WITHDRAWAL_METHOD_RESPONSE';
Const.RUN_DISABLE2FA = '/RUN_DISABLE2FA';
Const.RUN_CREATE_ACTIVITY = '/RUN_CREATE_ACTIVITY';
Const.RUN_GET_ACTIVITY = '/RUN_GET_ACTIVITY';
Const.RUN_GET_USER_LIST = '/RUN_GET_USER_LIST';
Const.RUN_WITHDRAWAL_METHODS = '/RUN_WITHDRAWAL_METHODS';
Const.RUN_GET_LOGS_LIST = '/RUN_GET_LOGS_LIST';
Const.RUN_GET_LOGS_VIEW = '/RUN_GET_LOGS_VIEW';
Const.RUN_GET_LOGS_DETAIL = '/RUN_GET_LOGS_DETAIL';
Const.RUN_GET_USER_VIEW = '/RUN_GET_USER_VIEW';
Const.RUN_EDIT_PAYMENT_METHODS = '/RUN_EDIT_PAYMENT_METHODS';
Const.RUN_DISABLE_PAYMET_METHOD = '/RUN_DISABLE_PAYMET_METHOD';
Const.RUN_UPDATE_CLIENT_DETAIL = '/RUN_UPDATE_CLIENT_DETAIL';
Const.RUN_RESET_PASSWORD = '/RUN_RESET_PASSWORD';
Const.RUN_USER_COUNT = '/RUN_USER_COUNT';
Const.RUN_USER_NOTIFICATIONS = '/RUN_USER_NOTIFICATIONS';
Const.RUN_ADD_WITHDRAWAL = '/RUN_ADD_WITHDRAWAL';
Const.RUN_ADD_TICKET = '/RUN_ADD_TICKET';
Const.RUN_GET_INTERNAL_NOTES = '/RUN_GET_INTERNAL_NOTES';
Const.RUN_ADD_INTERNAL_NOTES = '/RUN_ADD_INTERNAL_NOTES';
Const.RUN_GET_RISK_METRIX = '/RUN_GET_RISK_METRIX';
Const.RUN_VERIFY_ACCOUNT = '/RUN_VERIFY_ACCOUNT';
Const.RUN_CREATE_TRADING_ACCOUNT = '/RUN_CREATE_TRADING_ACCOUNT';
Const.RUN_SEND_MAIL = '/RUN_SEND_MAIL';
Const.RUN_REMOVE_USER = '/RUN_REMOVE_USER';
Const.SET_USER_LIST = '/SET_USER_LIST';
Const.GET_USER_LIST = '/GET_USER_LIST';
Const.SET_LOGS_LIST = '/SET_LOGS_LIST';
Const.GET_LOGS_LIST = '/GET_LOGS_LIST';
Const.SET_USER_VIEW = '/SET_USER_VIEW';
Const.GET_USER_VIEW = '/GET_USER_VIEW';
Const.SET_USER_COUNT = '/SET_USER_COUNT';
Const.GET_USER_COUNT = '/GET_USER_COUNT';
Const.SET_INTERNAL_NOTES = '/SET_INTERNAL_NOTES';
Const.GET_INTERNAL_NOTES = '/GET_INTERNAL_NOTES';
Const.SET_RISK_METRIX = '/SET_RISK_METRIX';
Const.GET_RISK_METRIX = '/GET_RISK_METRIX';
Const.SET_LOGS_VIEW = '/SET_LOGS_VIEW';
Const.GET_LOGS_VIEW = '/GET_LOGS_VIEW';
Const.GET_GENDER_LIST = '/GET_GENDER_LIST';
Const.GET_DEPT_METHD = '/GET_DEPT_METHD';
Const.GET_STEP = '/GET_STEP';
Const.GET_TIMEZONE = '/GET_TIMEZONE';
//deposit
Const.RUN_DEPOSIT_UPDATE_SUSPENSE = '/RUN_DEPOSIT_UPDATE_SUSPENSE';
Const.RUN_DEPOSIT_ASSIGN = '/RUN_DEPOSIT_ASSIGN';
Const.RUN_DEPOSIT_UPLOAD = '/RUN_DEPOSIT_UPLOAD';
Const.RUN_CREATE_DEPOSIT = '/RUN_CREATE_DEPOSIT';
Const.RUN_GET_DEPOSIT_LIST = '/RUN_GET_DEPOSIT_LIST';
Const.RUN_GET_DEPOSIT_VIEW = '/RUN_GET_DEPOSIT_VIEW';
Const.RUN_EDIT_DEPOSIT_DETAILS = '/RUN_EDIT_DEPOSIT_DETAILS';
Const.RUN_GET_DEPOSIT_TRANSACTION_STATUS = '/RUN_GET_DEPOSIT_TRANSACTION_STATUS';
Const.SET_DEPOSIT_LIST = '/SET_DEPOSIT_LIST';
Const.GET_DEPOSIT_LIST = '/GET_DEPOSIT_LIST';
Const.SET_DEPOSIT_VIEW = '/SET_DEPOSIT_VIEW';
Const.GET_DEPOSIT_VIEW = '/GET_DEPOSIT_VIEW';
Const.GET_DEPOSIT_STATUS = '/GET_DEPOSIT_STATUS';
Const.GET_DEPOSIT_METHOD = '/GET_DEPOSIT_METHOD';
Const.GET_BANK_OPTIONS = '/GET_BANK_OPTIONS';
//bonus
Const.RUN_GET_BONUS_LIST = '/RUN_GET_BONUS_LIST';
Const.RUN_GET_BONUS_VIEW = '/RUN_GET_BONUS_VIEW';
Const.RUN_GET_BONUS_DETAIL = '/RUN_GET_BONUS_DETAIL';
Const.RUN_ADD_BONUS = '/RUN_ADD_BONUS';
Const.SET_BONUS_LIST = '/SET_BONUS_LIST';
Const.GET_BONUS_LIST = '/GET_BONUS_LIST';
Const.SET_BONUS_VIEW = '/SET_BONUS_VIEW';
Const.GET_BONUS_VIEW = '/GET_BONUS_VIEW';
//ticket
Const.RUN_GET_TICKET_LIST = '/RUN_GET_TICKET_LIST';
Const.RUN_GET_TICKET_VIEW = '/RUN_GET_TICKET_VIEW';
Const.RUN_TICKET_REPLY = '/RUN_TICKET_REPLY';
Const.RUN_TICKET_APPROVE = '/RUN_TICKET_APPROVE';
Const.RUN_TICKET_TRANSFER = '/RUN_TICKET_TRANSFER';
Const.RUN_CLOSE_TICKET = '/RUN_CLOSE_TICKET';
Const.RUN_TICKET_DOC_APPROVE_REJECT = '/RUN_TICKET_DOC_APPROVE_REJECT';
Const.RUN_TICKET_APPROVE_MULTIPLE = '/RUN_TICKET_APPROVE_MULTIPLE';
Const.RUN_ESCALTE_TICKET = '/RUN_ESCALTE_TICKET';
Const.RUN_GET_GROUP_ADMIN_NAME = '/RUN_GET_GROUP_ADMIN_NAME';
Const.RUN_TICKET_REQUEST_OTP = '/RUN_TICKET_REQUEST_OTP';
//zip
Const.GET_ZIP_DOCS_LINK = '/GET_ZIP_DOCS_LINK';
Const.SET_TICKET_LIST = '/SET_TICKET_LIST';
Const.GET_TICKET_LIST = '/GET_TICKET_LIST';
Const.GET_IB_USER_DOCUMENT_LINK = '/GET_IB_USER_DOCUMENT_LINK';
Const.SET_TICKET_VIEW = '/SET_TICKET_VIEW';
Const.GET_TICKET_VIEW = '/GET_TICKET_VIEW';
Const.SET_TICKET_DOCS = '/SET_TICKET_DOCS';
Const.GET_TICKET_DOCS = '/GET_TICKET_DOCS';
Const.RUN_TICKET_REASON_LIST = '/RUN_TICKET_REASON_LIST';
Const.SET_TICKET_REASON_LIST = '/SET_TICKET_REASON_LIST';
Const.GET_TICKET_REASON_LIST = '/GET_TICKET_REASON_LIST';
Const.RUN_GET_TICKET_REASON_LIST = '/RUN_GET_TICKET_REASON_LIST';
Const.SET_TICKET_REASON_LIST1 = '/SET_TICKET_REASON_LIST1';
Const.GET_TICKET_REASON_LIST1 = '/GET_TICKET_REASON_LIST1';
Const.SET_TICKET_DATA = '/SET_TICKET_DATA';
Const.GET_TICKET_DATA = '/GET_TICKET_DATA';
Const.RUN_TICKET_CHECK_OTP = '/RUN_TICKET_CHECK_OTP';
Const.RUN_TICKET_RESEND_OTP = '/RUN_TICKET_RESEND_OTP';
Const.GET_TICKET_DOCS_LINK = '/GET_TICKET_DOCS_LINK';
Const.GET_DEPARMENT_LIST = '/GET_DEPARMENT_LIST';
Const.GET_LANGUAGE_LIST = '/GET_LANGUAGE_LIST';
Const.GET_TICKET_STATUS = '/GET_TICKET_STATUS';
Const.GET_TICKET_REASON = '/GET_TICKET_REASON';
Const.GET_TICKET_REPLY_PRE = '/GET_TICKET_REPLY_PRE';
//withdrawal
Const.RUN_DOWNLOAD_FILES = '/RUN_DOWNLOAD_FILES';
Const.RUN_SEND_WITH_DATA = '/RUN_SEND_WITH_DATA';
Const.RUN_GET_WITHDRAWAL_LIST = '/RUN_GET_WITHDRAWAL_LIST';
Const.RUN_GET_WITHDRAWAL_LIST_MAKER = '/RUN_GET_WITHDRAWAL_LIST_MAKER';
Const.RUN_GET_WITHDRAWAL_VIEW = '/RUN_GET_WITHDRAWAL_VIEW';
Const.RUN_EDIT_WITHDRAWAL_DETAILS = '/RUN_EDIT_WITHDRAWAL_DETAILS';
Const.SET_WITHDRAWAL_LIST = '/SET_WITHDRAWAL_LIST';
Const.SET_WITHDRAWAL_LIST_MAKER = '/SET_WITHDRAWAL_LIST_MAKER';
Const.GET_WITHDRAWAL_LIST = '/GET_WITHDRAWAL_LIST';
Const.GET_WITHDRAWAL_LIST_MAKER = '/GET_WITHDRAWAL_LIST_MAKER';
Const.SET_WITHDRAWAL_VIEW = '/SET_WITHDRAWAL_VIEW';
Const.GET_WITHDRAWAL_VIEW = '/GET_WITHDRAWAL_VIEW';
Const.GET_WITHDRAWAL_TYPE = '/GET_WITHDRAWAL_TYPE';
Const.GET_WITHDRAWAL_METHOD = '/GET_WITHDRAWAL_METHOD';
Const.GET_WITHDRAWAL_METHODS = '/GET_WITHDRAWAL_METHODS';
Const.GET_WITHDRAWAL_STATUS = '/GET_WITHDRAWAL_STATUS';
Const.GET_WITHDRAWAL_DOC_LINK = '/GET_WITHDRAWAL_DOC_LINK';
//trading
Const.RUN_GET_TRADING_LIST = '/RUN_GET_TRADING_LIST';
Const.RUN_GET_TRADING_VIEW = '/RUN_GET_TRADING_VIEW';
Const.RUN_EDIT_TRADING_DETAILS = '/RUN_EDIT_TRADING_DETAILS';
Const.RUN_CHANGE_LEVERAGE = '/RUN_CHANGE_LEVERAGE';
Const.RUN_DELETE_TRADING_ACCOUNT = '/RUN_DELETE_TRADING_ACCOUNT';
Const.SET_TRADING_LIST = '/SET_TRADING_LIST';
Const.GET_TRADING_LIST = '/GET_TRADING_LIST';
Const.SET_TRADING_VIEW = '/SET_TRADING_VIEW';
Const.GET_TRADING_VIEW = '/GET_TRADING_VIEW';
Const.RUN_DISABLE_TRADING_ACCOUNT = '/RUN_DISABLE_TRADING_ACCOUNT';
Const.GET_DEMO_LIVE = '/GET_DEMO_LIVE';
Const.GET_CURRENCY = '/GET_CURRENCY';
//bonus
Const.GET_BONUS_TYPE = '/GET_BONUS_TYPE';
Const.GET_BONUS_STATUS = '/GET_BONUS_STATUS';
//upload document
Const.RUN_UPLOAD_DOCUMENT = '/RUN_UPLOAD_DOCUMENT';
Const.RUN_UPLOAD_DOCUMENT_PIP = '/RUN_UPLOAD_DOCUMENT_PIP';
Const.GET_IB_TICKET_DOCUMENT_LINK = '/GET_IB_TICKET_DOCUMENT_LINK';
Const.RUN_GET_COMMISSION_TRADING_REPORT_LIST = '/RUN_GET_COMMISSION_TRADING_REPORT_LIST';
Const.RUN_GET_COMMISSION_REPORT_LIST = '/RUN_GET_COMMISSION_REPORT_LIST';
Const.SET_COMMISSION_REPORT_LIST = '/SET_COMMISSION_REPORT_LIST';
Const.GET_COMMISSION_REPORT_LIST = '/GET_COMMISSION_REPORT_LIST';
Const.RUN_GET_COMMISSION_WITHDRAWAL_LIST = '/RUN_GET_COMMISSION_WITHDRAWAL_LIST';
Const.SET_COMMISSION_WITHDRAWAL_LIST = '/SET_COMMISSION_WITHDRAWAL_LIST';
Const.GET_COMMISSION_WITHDRAWAL_LIST = '/GET_COMMISSION_WITHDRAWAL_LIST';
Const.RUN_GET_COMMISSION_REPORT_DETAIL = '/RUN_GET_COMMISSION_REPORT_DETAIL';
Const.SET_COMMISSION_REPORT_DETAIL = '/SET_COMMISSION_REPORT_DETAIL';
Const.GET_COMMISSION_REPORT_DETAIL = '/GET_COMMISSION_REPORT_DETAIL';
//Uploads List
Const.RUN_GET_UPLOADS_LIST = '/RUN_GET_UPLOADS_LIST';
Const.SET_UPLOADS_LIST = '/SET_UPLOADS_LIST';
Const.GET_UPLOADS_LIST = '/GET_UPLOADS_LIST';
//Client leads
Const.RUN_GET_CLIENT_LEADS = '/RUN_GET_CLIENT_LEADS';
Const.SET_CLIENT_LEADS = '/SET_CLIENT_LEADS';
Const.GET_CLIENT_LEADS = '/GET_CLIENT_LEADS';
// reassign leads
Const.RUN_REASSIGN_LEADS = '/RUN_REASSIGN_LEADS';
Const.RUN_UPDATE_LOYALTY_POINTS = '/RUN_UPDATE_LOYALTY_POINTS';
Const.RUN_ADMIN_ADD_DEPOSIT_METHODS = '/RUN_ADMIN_ADD_DEPOSIT_METHODS';
Const.RUN_GET_ADMIN_DEPOSIT_METHODS = '/RUN_GET_ADMIN_DEPOSIT_METHODS';
Const.SET_ADMIN_DEPOSIT_METHODS = '/SET_ADMIN_DEPOSIT_METHODS';
Const.GET_ADMIN_DEPOSIT_METHODS = '/GET_ADMIN_DEPOSIT_METHODS';
Const.RUN_ADMIN_CHANGE_WITHDRAWAL_METHOD = '/RUN_ADMIN_CHANGE_WITHDRAWAL_METHOD';
Const.RUN_ADMIN_CHANGE_DEPOSIT_METHOD = '/RUN_ADMIN_CHANGE_DEPOSIT_METHOD';
Const.RUN_LOYALITY_POINT_COUNT = '/RUN_LOYALITY_POINT_COUNT';
Const.SET_LOYALITY_POINT_COUNT = '/SET_LOYALITY_POINT_COUNT';
Const.GET_LOYALITY_POINT_COUNT = '/GET_LOYALITY_POINT_COUNT';
Const.RUN_CHANGE_ACCOUNT_LIMIT = '/RUN_CHANGE_ACCOUNT_LIMIT';
Const.RUN_CHANGE_ACCOUNT_TYPE = '/RUN_CHANGE_ACCOUNT_TYPE';
Const.RUN_UPDATE_WITHDRAWAL_DETAILS = '/RUN_UPDATE_WITHDRAWAL_DETAILS';
Const.RUN_UPDATE_DEPOSIT_DETAILS = '/RUN_UPDATE_DEPOSIT_DETAILS';
Const.RUN_LOCK_TRANSECTION = '/RUN_LOCK_TRANSECTION';
Const.RUN_UPDATE_WITHDRAWAL_COMMENT = '/RUN_UPDATE_WITHDRAWAL_COMMENT';
Const.RUN_UPDATE_DEPOSIT_COMMENT = '/RUN_UPDATE_DEPOSIT_COMMENT';
Const.RUN_UPLOAD_HELP2PAY_PRICE = '/RUN_UPLOAD_HELP2PAY_PRICE';
Const.RUN_TRADING_ACCOUNT_LIST = '/RUN_TRADING_ACCOUNT_LIST';
Const.RUN_CLICK_2_CALL = '/RUN_CLICK_2_CALL';
Const.RUN_CLICK_2_ENDCALL = '/RUN_CLICK_2_ENDCALL';
Const.RUN_GET_CLIENT_IB_LIST = '/RUN_GET_CLIENT_IB_LIST';
Const.RUN_GET_UPDATE_WITHDRAWAL_TICKET_TXNID = '/RUN_GET_UPDATE_WITHDRAWAL_TICKET_TXNID';
Const.RUN_GET_INTERNAL_TICKET_LIST = '/RUN_GET_INTERNAL_TICKET_LIST';
Const.RUN_INTERNAL_TICKET_REASON = '/RUN_INTERNAL_TICKET_REASON';
Const.SET_INTERNAL_TICKET_REASON = '/SET_INTERNAL_TICKET_REASON';
Const.GET_INTERNAL_TICKET_REASON = '/GET_INTERNAL_TICKET_REASON';



//////////////////
// WEBPACK FOOTER
// ./src/plugins/fxView/provider/candle-history/lib/const.cls.ts
// module id = H1/N
// module chunks = 90